// src/pages/LandingPage.js
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';

const LandingPage = () => {
  const navigate = useNavigate();
  const [showCTA, setShowCTA] = useState(false);
  const shimmerRef = useRef(null);
  const sparkRef = useRef(null);

  useEffect(() => {
    // Animation timing: shimmer lasts 5s, spark at 4.7s, CTA at 5.2s
    const shimmer = shimmerRef.current;
    const spark = sparkRef.current;
    if (shimmer) {
      shimmer.classList.add('shimmer-animate');
    }
    const sparkTimeout = setTimeout(() => {
      if (spark) spark.classList.add('spark-animate');
    }, 4700);
    const ctaTimeout = setTimeout(() => setShowCTA(true), 5200);
    return () => {
      clearTimeout(sparkTimeout);
      clearTimeout(ctaTimeout);
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900">
      <div className="relative flex items-center justify-center" style={{ minHeight: 440 }}>
        {/* Logo - double size, no white bg, white for this page only */}
        <Logo size={440} className="z-10 landing-logo-white" />
        {/* Shimmer overlay */}
        <div
          ref={shimmerRef}
          className="absolute top-0 left-0 w-full h-full pointer-events-none z-20 shimmer-mask"
        ></div>
        {/* Spark */}
        <div
          ref={sparkRef}
          className="absolute z-30 spark"
          style={{ right: 36, top: '50%', transform: 'translateY(-50%) scale(1.2)' }}
        ></div>
      </div>
      
      {/* CTA Buttons */}
      {showCTA && (
        <div className="mt-16 space-y-6">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-white mb-4">Choose Your Experience</h2>
            <p className="text-gray-400 mb-8">Are you a host or a player?</p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-6">
            <button
              className="px-10 py-4 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-xl text-xl font-bold shadow-lg hover:from-green-700 hover:to-green-800 transition-all duration-200 transform hover:scale-105"
              onClick={() => navigate('/login')}
            >
              🎤 I'm a Host
              <div className="text-sm font-normal mt-1 opacity-90">
                Build, Buy, Sell and Host Trivia
              </div>
            </button>
            
            <button
              className="px-10 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl text-xl font-bold shadow-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-200 transform hover:scale-105"
              onClick={() => navigate('/player-hub')}
            >
              🏆 I'm a Player
              <div className="text-sm font-normal mt-1 opacity-90">
                Compete and Compare GPAs
              </div>
            </button>
          </div>
        </div>
      )}
      
      {/* Animation styles */}
      <style>{`
        .shimmer-mask {
          background: linear-gradient(270deg, rgba(255,255,255,0) 40%, rgba(255,255,255,0.7) 50%, rgba(255,255,255,0) 60%);
          background-size: 200% 100%;
          background-repeat: no-repeat;
          opacity: 0;
          filter: blur(2px);
          mix-blend-mode: lighten;
          border-radius: 24px;
        }
        .shimmer-animate {
          animation: shimmer-move 5s cubic-bezier(0.4,0,0.2,1) 1 forwards;
        }
        @keyframes shimmer-move {
          0% { background-position: 120% 0; opacity: 0; }
          10% { opacity: 0.7; }
          15% { opacity: 0.8; }
          85% { opacity: 0.8; background-position: -100% 0; }
          90% { opacity: 0; background-position: -100% 0; }
          100% { opacity: 0; background-position: -100% 0; }
        }
        .spark {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: radial-gradient(circle, #fff 0%, #fffbe6 40%, #fff0 70%);
          opacity: 0;
          box-shadow: 0 0 24px 8px #fffbe6, 0 0 48px 16px #fffbe6;
          pointer-events: none;
        }
        .spark-animate {
          animation: spark-flash 0.7s cubic-bezier(0.4,0,0.2,1) 1;
        }
        @keyframes spark-flash {
          0% { opacity: 0; transform: scale(0.5); }
          40% { opacity: 1; transform: scale(1.3); }
          80% { opacity: 1; transform: scale(1); }
          100% { opacity: 0; transform: scale(0.5); }
        }
        .landing-logo-white {
          filter: brightness(0) invert(1) drop-shadow(0 0 16px #fff8);
        }
      `}</style>
    </div>
  );
};

export default LandingPage;
